import type { PlayInfo } from '@module/apis/client-side/live/type';
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useFreezeChat from '@module/helpers/chat/useFreezeChat';
import { aspCond } from '@module/helpers/conditions/condition';
//import { aspCond } from '@module/helpers/conditions/condition';
import { useBroadcastSponPopoverStore } from '@module/stores/useBroadcastSponPopoverStore';
// import useChatPanelStore from '@module/stores/useChatPanelStore';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import useModalStore from '@module/stores/useModalStore';
import useSocketStore from '@module/stores/useSocketStore';
import { LiveGift } from '@module/svg/icons';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import { spaAdvert } from '@module/utils/advert';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import SwitchButton from '@pc/components/atoms/button/SwitchButton';
import ToastBody from '@pc/components/atoms/toast/ToastBody';
import BaseSVG from '@pc/components/image/BaseSVG';
import BaseLottie from '@pc/components/lottie/BaseLottie';
import React, { useCallback } from 'react';
import toast, { type Toast } from 'react-hot-toast';
interface Props {
  playInfo: PlayInfo;
  isRoomMaster: boolean;
  mediaCode: string;
}
function SendChatToolBox({
  playInfo,
  isRoomMaster,
  mediaCode
}: Props) {
  const token = useSocketStore(state => state.token);
  const {
    isLogin,
    userInfo
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore();
  const {
    isDark
  } = useIsDarkModeStore();
  const {
    freezeChat
  } = useFreezeChat();
  // const toggleChattingSetting = useChatPanelStore((state) => state.toggleChattingSetting);
  // const setIsChatEmoticonSelectBoxOpen = useChatPanelStore((state) => state.setIsChatEmoticonSelectBoxOpen);
  // const clearSelectedBlockEmoticon = useChatPanelStore((state) => state.clearSelectedBlockEmoticon);
  const handleReportClick = useCallback(() => {
    if (!isLogin) {
      if (aspCond.if('new-asp')) {
        SettingConfig.aspUtils?.goLogin();
        return;
      }
      pushModal({
        type: MODAL_TYPE_PC.AUTH_MODAL,
        id: 'SendChatToolBox'
      });
      toast((m: Toast) => <ToastBody id={m.id} content='로그인 후 이용 가능합니다.' />);
      return;
    }
    pushModal({
      type: MODAL_TYPE_PC.REPORT_MODAL,
      id: 'SendChatToolBox',
      options: {
        toUserIdx: playInfo.media.userIdx,
        toUserNickName: playInfo.media.userNick,
        toUserId: playInfo.media.userId,
        mediaCode: playInfo.media.code,
        type: 'cast',
        broadcastTitle: playInfo.media.title,
        broadcastId: playInfo.media.userId,
        broadcastNickName: playInfo.media.userNick
      }
    });
  }, [playInfo, pushModal, isLogin]);
  const handleSponClick = useCallback(() => {
    if (!isLogin) {
      if (aspCond.if('new-asp')) {
        SettingConfig.aspUtils?.goLogin();
        return;
      }
      pushModal({
        type: MODAL_TYPE_PC.AUTH_MODAL,
        id: 'SendChatToolBox'
      });
      toast((m_0: Toast) => <ToastBody id={m_0.id} content='로그인 후 이용 가능합니다.' />);
      return;
    }
    useBroadcastSponPopoverStore.getState().setIsOpen(!useBroadcastSponPopoverStore.getState().isOpen);
    if (userInfo) {
      spaAdvert('openLayer', {
        code: 'spon',
        userIdx: userInfo.idx
      });
    }
  }, [playInfo, pushModal, isLogin, token]);
  return <div className='flex items-center'>
      {/* 상망 기준 기능 제거 */}
      {/* {!aspCond.if('asp') && !SettingConfig.isProd && (
        <BaseButton
          data-gtm-chat-setting-button
          tooltip={{ content: '채팅 설정', side: 'top' }}
          type='button'
          size='none'
          variant='ghost'
          className='mt-[8px]'
          onClick={() => {
            toggleChattingSetting();
            setIsChatEmoticonSelectBoxOpen(false);
            clearSelectedBlockEmoticon();
          }}
        >
          <BaseSVG
            src={
              isDark
                ? `${SettingConfig.S3_BUCKET_URL}/img/icon/icon_global_setting_dark.svg`
                : `${SettingConfig.S3_BUCKET_URL}/img/icon/ico_global_setting.svg`
            }
            width={30}
            height={30}
          />
        </BaseButton>
       )} */}

      {isRoomMaster && <div className='flex items-center'>
          <span className='mr-1.5 text-colorFg01 text-sm'>채팅</span>
          <SwitchButton buttonSize='md' checked={playInfo.roomFreezeInfo?.enable} onChange={e => {
        freezeChat({
          action: e.target.checked ? 'on' : 'off',
          mediaCode
        });
      }} />
        </div>}
      {!isRoomMaster && token && <BaseButton id='chat-report-button' data-gtm-chat-report-button tooltip={{
      content: '신고',
      side: 'top'
    }} type='button' size='none' variant='ghost' className='mt-[8px] ml-2' aria-haspopup='true' aria-expanded='false' onClick={handleReportClick}>
          <BaseSVG src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_police.svg`} width={18} height={18} />
        </BaseButton>}
      {!isRoomMaster && token && <BaseButton data-gtm-chat-spon-button tooltip={{
      content: '선물',
      side: 'top'
    }} type='button' size='none' variant='ghost' className='ml-[11px]' onClick={handleSponClick}>
          <BaseLottie className='h-[30px] w-[30px]' src={isDark ? `${SettingConfig.S3_BUCKET_URL}/json/lottie/dark_ico_live_gift_B.json` : `${SettingConfig.S3_BUCKET_URL}/json/lottie/ico_live_gift_B.json`} fallback={<LiveGift className='flex items-end' style={{
        width: 30,
        height: 30
      }} />} />
        </BaseButton>}
    </div>;
}
export default React.memo(SendChatToolBox);